var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.CrowdfundingGuideLink },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-info-hero gfu-info-hero--guide _jc-c" }, [
        _c("div", { staticClass: "gfu-info-hero__cover" }),
        _vm._v(" "),
        _c("div", { staticClass: "gfu-info-hero__content" }, [
          _c(
            "h1",
            {
              staticClass:
                "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4",
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.Resources.CrowdfundingGuide.PageHeader) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(
            "\n            Wondering what crowdfunding is all about or how it actually works? "
          ),
          _c("br"),
          _vm._v(
            "\n            Here's a simple guide to help you understand the basics.\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "_pos-r js-main-content" },
        [
          _c(
            "div",
            {
              staticClass:
                "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 _flexcol _gap-6",
            },
            [
              _c(
                "box",
                { staticClass: "_flexcol _gap-6", attrs: { huge: "" } },
                [
                  _c("div", { staticClass: "_flexcol _gap-4" }, [
                    _c("div", [
                      _c("strong", { staticClass: "_tc--dark" }, [
                        _vm._v(
                          "\n                        Crowdfunding is all about turning cool ideas into reality with the help of a supportive community. Instead of buying something that’s already on the shelf, you’re backing a project before it’s made – which means it can take a little time for the product to be created and delivered.\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                        At its heart, crowdfunding is a meeting place for creators with bold ideas and people excited to see them come to life. When you support a project, you’re not just ordering a product – you’re joining the journey. You’ll often get early access, one-of-a-kind rewards, and the satisfaction of knowing you played a role in bringing something new into the world.\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                        This guide will walk you through how crowdfunding works, so you'll know what to expect before jumping in.\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "_tac" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { shape: "soft", theme: "accent" },
                          on: { click: _vm.onGlossaryOpen },
                        },
                        [_vm._v("View crowdfunding glossary")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("base-title", { attrs: { as: "h3", level: "h2" } }, [
                    _vm._v("Campaign stages"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    Crowdfunding projects move through several stages, each with its own role and opportunities. Knowing what happens when will help you follow along, decide how to take part, and understand when things like pledging or sharing your shipping details come into play.\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("box", {
                staticClass:
                  "gfu-box--content _foh gfu-bt gfu-bt--b1 gfu-crowdfunding-guide__box",
                attrs: { content: true },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "gfu-crowdfunding-guide__content" },
                          _vm._l(_vm.stages, function (section) {
                            return _c(
                              "div",
                              {
                                key: section.sectionID,
                                class: [
                                  {
                                    "gfu-media-description--reverse":
                                      section.isReversed,
                                  },
                                  "gfu-media-description _mb-6",
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gfu-media-description__body",
                                  },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        ref: section.sectionID,
                                        refInFor: true,
                                        staticClass:
                                          "gfu-hd gfu-hd--h2 gfu-heading--top-divider",
                                        attrs: { id: section.sectionID },
                                      },
                                      [_vm._v(_vm._s(section.header))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "_mt-3",
                                      domProps: {
                                        innerHTML: _vm._s(section.paragraph),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gfu-media-description__aside",
                                  },
                                  [
                                    _c("themed-image", {
                                      attrs: {
                                        src: section.image,
                                        alt: section.header,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c("base-title", { attrs: { as: "h3", level: "h2" } }, [
                _vm._v("Concept Explanation"),
              ]),
              _vm._v(" "),
              _c("box", {
                staticClass:
                  "gfu-box--content _foh gfu-bt gfu-bt--b1 gfu-crowdfunding-guide__box",
                attrs: { content: true },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "gfu-crowdfunding-guide__content" },
                          [
                            _vm._l(
                              _vm.crowdfundingGuideMediaModel,
                              function (section) {
                                return _c(
                                  "div",
                                  {
                                    key: section.sectionID,
                                    class: [
                                      {
                                        "gfu-media-description--reverse":
                                          section.isReversed,
                                      },
                                      "gfu-media-description _mb-6",
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "gfu-media-description__body",
                                      },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            ref: section.sectionID,
                                            refInFor: true,
                                            staticClass:
                                              "gfu-hd gfu-hd--h2 gfu-heading--top-divider",
                                            attrs: { id: section.sectionID },
                                          },
                                          [_vm._v(_vm._s(section.header))]
                                        ),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "_mt-3" }, [
                                          _vm._v(_vm._s(section.paragraph)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "gfu-media-description__aside",
                                      },
                                      [
                                        _c("themed-image", {
                                          attrs: {
                                            src: section.image,
                                            alt: section.header,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.stepsExplanationModel,
                              function (section) {
                                return _c(
                                  "div",
                                  {
                                    key: section.sectionID,
                                    staticClass: "_mt-4",
                                  },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        ref: section.sectionID,
                                        refInFor: true,
                                        staticClass:
                                          "gfu-hd gfu-hd--h3 _ttu _flex",
                                        attrs: { id: section.sectionID },
                                      },
                                      [
                                        _c("base-icon", {
                                          staticClass:
                                            "_mr-1 gfu-icon--big _tc--accent",
                                          attrs: {
                                            name: section.icon,
                                            "icon-namespace":
                                              section.iconNamespace,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "gfu-icon--hd" },
                                          [_vm._v(_vm._s(section.header))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "_mt-3" }, [
                                      _vm._v(_vm._s(section.paragraph)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("table-of-contents"),
          _vm._v(" "),
          _c("crowdfunding-glossary-modal", {
            attrs: { "is-visible": _vm.isGlossaryVisible },
            on: { close: _vm.onGlossaryClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }